import React from 'react';

import config from '@/utils/config';
import FeedbackForm from './FeedbackForm';

import style from './style.module.scss';

type AppProps = any;

const App: React.VFC<AppProps> = () => {
  return (
    <div
      className={cn(style.widget, config.get('widgetClassName'))}
      style={config.get('widgetStyle')}
    >
      <div className={style.container}>
        <FeedbackForm />
      </div>
    </div>
  );
};

export default App;
